jQuery(document).ready(function($) {

    if ($('.scrollable-posts').length > 0) {

        // if width longer than container
        var containerWidth = $('.scrollable-posts').width();
        var containerFullWidth = $('.scrollable-posts__inner')[0].scrollWidth;
        var itemWidth = $('.scrollable_post').outerWidth();
        var fourItems = itemWidth * 4;
        console.log(containerWidth);
        console.log(containerFullWidth);

        var numPages = containerFullWidth / containerWidth;

        if (containerFullWidth > containerWidth) {

            // if there less than 2 pages of results
            if ((containerFullWidth / 2) < containerWidth ) {

                console.log('less than 2 pages of results');
                $('.scrollable-posts').find('.next').addClass('visible');

                $('.scrollable-posts-nav').click(function(){
                    if ($(this).hasClass('next')) {
                        console.log('next');
                        $('.scrollable-posts .scrollable_post').css('right',containerFullWidth - containerWidth);
                        $(this).removeClass('visible');
                        $('.scrollable-posts-nav.prev').addClass('visible');
                    } else {
                        console.log('not next');
                        $('.scrollable-posts .scrollable_post').css('right',0);
                        $(this).removeClass('visible');
                        $('.scrollable-posts-nav.next').addClass('visible');
                    }
                    
                });

            } else { // 2 or more pages of results
                console.log('more than 1 pages of results');

                $('.scrollable-posts').find('.next').addClass('visible');

                $('.scrollable-posts-nav').click(function(){
                    var right = parseInt($('.scrollable-posts .scrollable_post').css('right'));
                    var oldPageNum = parseFloat($('.scrollable-posts').attr('data-page'));
                    console.log();

                    if ($(this).hasClass('next')) {
                        console.log('NEXT');
                        $('.scrollable-posts').attr('data-page',oldPageNum+1);
                        $('.scrollable-posts .scrollable_post').css('right',right+containerWidth);
                        $('.scrollable-posts-nav.prev').addClass('visible');
                        if (oldPageNum >= (numPages-1)) {
                            $(this).removeClass('visible');
                            $('.scrollable-posts-nav.prev').addClass('visible');
                        }
                    } else {
                        console.log('PREV!?');
                        $('.scrollable-posts').attr('data-page',oldPageNum-1);
                        $('.scrollable-posts .scrollable_post').css('right',right-containerWidth);
                        if (oldPageNum <= 2) {
                            $(this).removeClass('visible');
                            $('.scrollable-posts-nav.next').addClass('visible');
                        }
                    }
                    
                });

            }

        }

    }

});